import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import TopAppBar from '../../components/feature/TopAppBar';
import BottomTabBar from '../../components/feature/BottomTabBar';

export default function Profile() {
  const { t, i18n } = useTranslation();
  const [showLanguageModal, setShowLanguageModal] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState(i18n.language);

  const handleLanguageChange = (lang: string) => {
    setSelectedLanguage(lang);
    i18n.changeLanguage(lang);
    setShowLanguageModal(false);
  };

  const getCurrentLanguageLabel = () => {
    return i18n.language === 'en' ? t('english') : t('swedish');
  };

  const settingsGroups = [
    {
      title: t('personalInfo'),
      items: [
        {
          icon: 'ri-user-line',
          label: t('personalInfo'),
          value: t('personalInfoDesc'),
          action: () => {},
        },
        {
          icon: 'ri-e-bike-2-line',
          label: t('vehicle'),
          value: t('vehicleDesc'),
          action: () => {},
        },
        {
          icon: 'ri-global-line',
          label: t('language'),
          value: getCurrentLanguageLabel(),
          action: () => setShowLanguageModal(true),
        },
      ],
    },
    {
      title: t('support'),
      items: [
        {
          icon: 'ri-question-line',
          label: t('helpCenter'),
          value: t('helpCenterDesc'),
          action: () => {},
        },
        {
          icon: 'ri-customer-service-2-line',
          label: t('contactSupport'),
          value: t('contactSupportDesc'),
          action: () => {},
        },
      ],
    },
    {
      title: t('legal'),
      items: [
        {
          icon: 'ri-file-text-line',
          label: t('termsOfService'),
          value: '',
          action: () => {},
        },
        {
          icon: 'ri-shield-check-line',
          label: t('privacyPolicy'),
          value: '',
          action: () => {},
        },
      ],
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50 pb-20">
      <TopAppBar title={t('profile')} />

      <div className="pt-14 px-4">
        <div className="bg-gradient-to-br from-[#E31837] to-[#C41530] rounded-3xl p-6 shadow-lg mb-6 mt-4">
          <div className="flex items-center gap-4">
            <div className="w-20 h-20 rounded-full bg-white/20 flex items-center justify-center">
              <i className="ri-user-fill text-4xl text-white"></i>
            </div>
            <div>
              <h2 className="text-white text-xl font-bold mb-1">Erik Andersson</h2>
              <p className="text-white/90 text-sm">erik.andersson@email.com</p>
              <p className="text-white/90 text-sm">+46 70 123 4567</p>
            </div>
          </div>
        </div>

        <div className="space-y-6">
          {settingsGroups.map((group, groupIndex) => (
            <div key={groupIndex}>
              <h3 className="text-sm font-bold text-gray-900 mb-3 px-1">{group.title}</h3>
              <div className="bg-white rounded-2xl shadow-md overflow-hidden">
                {group.items.map((item, itemIndex) => (
                  <button
                    key={itemIndex}
                    onClick={item.action}
                    className="w-full flex items-center justify-between p-4 border-b border-gray-100 last:border-0 hover:bg-gray-50 transition-colors"
                  >
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center">
                        <i className={`${item.icon} text-lg text-gray-700`}></i>
                      </div>
                      <div className="text-left">
                        <p className="text-sm font-semibold text-gray-900">{item.label}</p>
                        {item.value && <p className="text-xs text-gray-600">{item.value}</p>}
                      </div>
                    </div>
                    <i className="ri-arrow-right-s-line text-xl text-gray-400"></i>
                  </button>
                ))}
              </div>
            </div>
          ))}
        </div>

        <button className="w-full bg-white rounded-2xl p-4 shadow-md mt-6 flex items-center justify-center gap-2 text-red-600 font-semibold hover:bg-red-50 transition-colors">
          <i className="ri-logout-box-line text-xl"></i>
          <span>{t('logout')}</span>
        </button>
      </div>

      {showLanguageModal && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-end">
          <div className="bg-white w-full rounded-t-3xl p-6 animate-slide-up">
            <h3 className="text-lg font-bold text-gray-900 mb-4">{t('selectLanguage')}</h3>
            <div className="space-y-2 mb-4">
              <button
                onClick={() => handleLanguageChange('sv')}
                className={`w-full flex items-center justify-between p-4 rounded-xl transition-all ${
                  selectedLanguage === 'sv' ? 'bg-[#E31837] text-white' : 'bg-gray-100 text-gray-900'
                }`}
              >
                <span className="font-semibold">{t('swedish')}</span>
                {selectedLanguage === 'sv' && <i className="ri-check-line text-xl"></i>}
              </button>
              <button
                onClick={() => handleLanguageChange('en')}
                className={`w-full flex items-center justify-between p-4 rounded-xl transition-all ${
                  selectedLanguage === 'en' ? 'bg-[#E31837] text-white' : 'bg-gray-100 text-gray-900'
                }`}
              >
                <span className="font-semibold">{t('english')}</span>
                {selectedLanguage === 'en' && <i className="ri-check-line text-xl"></i>}
              </button>
            </div>
            <button
              onClick={() => setShowLanguageModal(false)}
              className="w-full bg-gray-200 text-gray-900 font-semibold py-3 rounded-xl"
            >
              {t('cancel')}
            </button>
          </div>
        </div>
      )}

      <BottomTabBar />
    </div>
  );
}
